import React = require("react");
import useConfig from "../hooks/useConfig";
import ensureProtocol from "../helpers/ensureProtocol";
import PoweredBy from "./PoweredBy";

interface Props {
  children?: React.ReactNode;
}

export default function MessengerFlexContainer(props: Props) {
  const config = useConfig();

  return (
    <div className="velaro-messenger-flex">
      {props.children}
      {config.CustomFooterEnabled && (
        <div className="velaro-custom-footer">
          <a
            href={ensureProtocol(config.CustomFooterUrl)}
            target="_blank"
            rel="noopener noreferrer"
          >
            {config.CustomFooterText}
          </a>
        </div>
      )}
      {config.EnablePoweredBy && <PoweredBy />}
    </div>
  );
}
